export enum InternalEventPublishStrategy {
  ASYNC = 'ASYNC',
  SEQUENCE = 'SEQUENCE',
}
